import React from 'react';
import {FieldViewSmallProps} from "../../../../render/view-small";
import FieldUrl_ActionClick from "../actions/url-click";

export default function FieldUrl_ViewSmall(props:FieldViewSmallProps) {

    const value = _.get(props.model, props.field.fieldId, null)

    const onClick = (e:React.SyntheticEvent) => {
        e.stopPropagation()
        FieldUrl_ActionClick(value)
    }

    return (
        <div className="ui5-link-small no-underline txt-truncate" onClick={onClick}>
            {value}
        </div>
    )
}
